(() => {
  const docEl = document.documentElement;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const hasGsap = !!(window.gsap && window.ScrollTrigger);
  const motion = !reduced && hasGsap;
  if (motion) docEl.classList.add("motion"); else docEl.classList.add("static");
  const fmt = n => Math.round(n).toLocaleString("en-US");
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const phone = matchMedia("(max-width: 760px)").matches;

  /* ---------- Theme: follows the system; the toggle overrides and is remembered ---------- */
  const themeBtn = $("#themeBtn"), themeMeta = document.querySelector('meta[name="theme-color"]'), sysLight = matchMedia("(prefers-color-scheme: light)");
  const eff = () => docEl.dataset.theme || (sysLight.matches ? "light" : "dark");
  function applyTheme() {
    const e = eff();
    themeBtn.setAttribute("aria-label", e === "light" ? "Switch to dark mode" : "Switch to light mode");
    if (themeMeta) themeMeta.content = e === "light" ? "#F5F5F7" : "#0A0A0A";
  }
  themeBtn.addEventListener("click", () => {
    docEl.dataset.theme = eff() === "light" ? "dark" : "light";
    try { localStorage.setItem("qua-theme", docEl.dataset.theme); } catch (e) {}
    applyTheme();
  });
  sysLight.addEventListener("change", applyTheme);
  applyTheme();

  /* ---------- Header: menu, smooth scroll, active link ---------- */
  const header = $("#header"), menuBtn = $("#menuBtn");
  const setMenu = open => { header.classList.toggle("nav-open", open); menuBtn.setAttribute("aria-expanded", open); menuBtn.setAttribute("aria-label", open ? "Close menu" : "Open menu"); };
  menuBtn.addEventListener("click", () => setMenu(!header.classList.contains("nav-open")));
  addEventListener("keydown", e => { if (e.key === "Escape") setMenu(false); });
  $$('a[href^="#"]').forEach(a => a.addEventListener("click", e => {
    const id = a.getAttribute("href"); if (id === "#privacy") return;
    const t = id === "#top" ? document.body : document.querySelector(id); if (!t) return;
    e.preventDefault(); setMenu(false);
    const y = id === "#top" || id === "#bottle" ? 0 : t.getBoundingClientRect().top + scrollY - 80;
    scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" });
  }));
  const links = $$(".nav a");
  const navIO = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) links.forEach(l => l.classList.toggle("active", l.getAttribute("href") === "#" + e.target.id));
  }), { rootMargin: "-45% 0px -50% 0px" });
  // every section is watched, so the highlight clears in parts that have no menu item (calculator, waitlist, footer)
  ["bottle", "problem", "today", "day", "qai", "app", "waitlist"].forEach(id => navIO.observe(document.getElementById(id)));

  /* ---------- Reveal once on arrival ---------- */
  const revealIO = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add("in"); revealIO.unobserve(e.target);
    e.target.dispatchEvent(new Event("arrive"));
  }), { rootMargin: phone ? "0px 0px -3% 0px" : "0px 0px -12% 0px" }); // on phones sections arrive sooner, so no blank band at the bottom
  $$("[data-reveal], #timeline, #dots").forEach(el => revealIO.observe(el));

  /* Count a number up once, ease-out */
  function countUp(el, from, to, ms) {
    if (!motion) { el.textContent = fmt(to); return; }
    const t0 = performance.now();
    const step = t => { const p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(from + (to - from) * e); if (p < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }

  /* ---------- The bottle: the render's own turning frames on canvas, the ring's glow and its light on the floor ---------- */
  const COUNT = 36, frames = [], ringMask = new Image();
  const qb = $(".bottle"), body = qb.querySelector(".body"), ring = qb.querySelector(".ring"), spill = qb.querySelector(".spill");
  const bx = body.getContext("2d"), rx = ring.getContext("2d"), sx = spill.getContext("2d");
  let shown = -1, want = 0;
  function draw(i) {
    want = i; let f = i;
    for (let d = 0; d < COUNT && !frames[f]?.naturalWidth; d++) f = (i + d + 1) % COUNT;
    if (f === shown || !frames[f]?.naturalWidth) return;
    shown = f;
    const w = body.width, h = body.height, rw = ring.width, rh = ring.height;
    if (!w || !h) { shown = -1; return; } // not laid out yet; size() draws again
    bx.clearRect(0, 0, w, h); bx.drawImage(frames[f], 0, 0, w, h);
    rx.globalCompositeOperation = "source-over"; rx.clearRect(0, 0, rw, rh); rx.drawImage(frames[f], 0, 0, rw, rh);
    if (ringMask.naturalWidth) { rx.globalCompositeOperation = "destination-in"; rx.drawImage(ringMask, 0, 0, rw, rh); } else rx.clearRect(0, 0, rw, rh);
    sx.clearRect(0, 0, spill.width, spill.height); sx.drawImage(ring, 0, 0, spill.width, spill.height);
  }
  // On phones the two glows are drawn small and stretched: the softness comes free, with no blur to redo every frame
  function size() {
    const dpr = Math.min(devicePixelRatio || 1, phone ? 1.25 : 1.5), cw = body.clientWidth, ch = body.clientHeight;
    body.width = cw * dpr; body.height = ch * dpr;
    const rs = phone ? .25 : dpr, ss = phone ? 1 / 12 : dpr;
    ring.width = Math.max(1, Math.round(cw * rs)); ring.height = Math.max(1, Math.round(ch * rs));
    spill.width = Math.max(1, Math.round(cw * ss)); spill.height = Math.max(1, Math.round(ch * ss));
    shown = -1; draw(want);
  }
  for (let i = 0; i < COUNT; i++) {
    const img = new Image(); img.decoding = "async";
    img.onload = () => { if (i === want) shown = -1; draw(want); };
    img.src = window.QUA.frames[i]; frames[i] = img;
  }
  ringMask.onload = () => { shown = -1; draw(want); };
  ringMask.src = window.QUA.ringMask;
  let lastW = innerWidth;
  addEventListener("resize", () => { if (innerWidth !== lastW) { lastW = innerWidth; size(); setDotColours(); } });
  size();

  /* ---------- How much today ---------- */
  const kg = $("#kg"), train = $("#train"), wxBtns = $$("#wx button");
  let heat = 250;
  const r50 = n => Math.round(n / 50) * 50;
  function renderCalc() {
    const k = +kg.value, m = +train.value;
    const raw = r50(k * 33 + heat + m * 10), total = Math.min(4000, Math.max(1500, raw)), diff = total - 2000;
    // the target always stays between 1,500 and 4,000 mL a day (as in the app); say so when a limit is reached
    const note = $("#capNote"); note.hidden = raw === total;
    note.textContent = raw > total ? "Capped at 4,000 mL a day. Above that, ask a doctor." : raw < total ? "Never less than 1,500 mL a day." : "";
    $("#kgOut").textContent = k + " kg";
    $("#trainOut").textContent = m === 0 ? "Rest day" : m + " min";
    $("#total").textContent = fmt(total);
    $("#totalLive").textContent = "Your number today: " + fmt(total) + " mL";
    $("#barYou").style.transform = `scaleX(${total / 4000})`;
    $("#gapLine").textContent = diff > 0 ? fmt(diff) + " mL more than eight glasses." : diff < 0 ? fmt(-diff) + " mL less than eight glasses." : "Exactly eight glasses. A rare day.";
    $("#pBody").textContent = fmt(r50(k * 33)) + " mL";
    $("#pWx").textContent = "+" + fmt(heat) + " mL";
    $("#pTr").textContent = "+" + fmt(m * 10) + " mL";
    for (const r of [kg, train]) r.style.setProperty("--p", (r.value - r.min) / (r.max - r.min) * 100 + "%");
  }
  kg.addEventListener("input", renderCalc); train.addEventListener("input", renderCalc);
  wxBtns.forEach(b => b.addEventListener("click", () => { wxBtns.forEach(x => x.setAttribute("aria-checked", x === b)); heat = +b.dataset.heat; renderCalc(); }));
  renderCalc();

  /* ---------- Numbers that count up on arrival ---------- */
  $(".facts .stat").addEventListener("arrive", () => $$("[data-count]").forEach(el => countUp(el, 0, +el.dataset.count, 900)));
  $("#ledger").addEventListener("arrive", () => setTimeout(() => countUp($("#qaiTotal"), 2350, 2850, 900), 600));

  /* ---------- Closing: 250 dots, one per person, in Sunset; they light in a wave ---------- */
  const dots = $("#dots"), SUN = [[248, 24, 246], [249, 125, 162], [251, 229, 76]];
  // ponytail: JOINED comes from the theme setting "Waitlist count", updated by hand; a live count needs a small app later
  let JOINED = Math.max(0, +window.QUA.joined || 0);
  for (let i = 0; i < Math.max(250, JOINED); i++) { const d = document.createElement("i"); if (i >= JOINED) d.className = "seat"; dots.appendChild(d); }
  function setDotColours() {
    const cols = parseInt(getComputedStyle(dots).getPropertyValue("--cols")) || 50;
    [...dots.children].forEach((d, i) => {
      const c = i % cols, r = Math.floor(i / cols), t = c / (cols - 1);
      const [p, q, u] = t < .5 ? [SUN[0], SUN[1], t * 2] : [SUN[1], SUN[2], t * 2 - 1];
      d.style.setProperty("--c", `rgb(${p.map((v, k) => Math.round(v + (q[k] - v) * u)).join(",")})`);
      d.style.setProperty("--d", c * 16 + r * 40 + "ms");
    });
  }
  setDotColours();
  dots.addEventListener("arrive", () => countUp($("#joinedCount"), 0, JOINED, 1200));
  function welcome(n) {
    JOINED = n || JOINED + 1;
    // this browser remembers its Early Duck, so coming back shows the same badge instead of a new number
    try { localStorage.setItem("qua-duck", JSON.stringify({ n: JOINED, date: new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric" }).format(new Date()) })); } catch (e) {}
    if (window.quaEarlyDuck) { window.quaEarlyDuck.open(JOINED - 1, JOINED, landOnSite); return; }
    landOnSite();
  }
  /* as the number lands in the moment, the site's own count turns and a new dot lights, behind the blur */
  function landOnSite() {
    let d = dots.children[JOINED - 1]; if (!d) { d = document.createElement("i"); dots.appendChild(d); } d.classList.remove("seat"); setDotColours();
    d.style.setProperty("--d", "0ms"); d.classList.add("new");
    const b = $("#joinedCount"); countUp(b, JOINED - 1, JOINED, 700);
    b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump");
    $("#you").textContent = "You're number " + fmt(JOINED) + "."; $("#you").hidden = false;
  }

  const myDuck = () => { try { return JSON.parse(localStorage.getItem("qua-duck") || "null"); } catch (e) { return null; } };
  $("#viewBadge").addEventListener("click", () => {
    if (!window.quaEarlyDuck) return;
    const mine = myDuck();
    if (mine && mine.n) window.quaEarlyDuck.restore(mine.n, mine.date, mine.name); else window.quaEarlyDuck.reopen();
  });

  /* ---------- Waitlist form ---------- */
  /* A real Shopify sign-up form. Shopify's invisible spam check protects it: when the check passes it adds its token
     and calls the form's own submit(), which here sends in the background, so the page never reloads. */
  const form = $("#form"), msg = $("#msg"), btn = form.querySelector("button");
  const isBound = f => f.hasAttribute("data-hcaptcha-bound");
  const waitForBinding = f => new Promise(res => { const t0 = Date.now(); (function check() { if (isBound(f)) return res(true); if (Date.now() - t0 > 4000) return res(false); setTimeout(check, 100); })(); });
  const protect = f => { try { window.Shopify && Shopify.captcha && Shopify.captcha.protect(f); } catch (e) {} };
  function sendInBackground(f, done, visibleCheckOk) {
    return () => fetch(f.action, { method: "POST", body: new FormData(f), credentials: "same-origin" }).then(r => {
      if (r.url.includes("customer_posted=true")) return done(true);
      // Shopify wants a visible check from this visitor (e.g. the same email again and again): go to Shopify's own
      // check page; it sends the sign-up on and brings them back with ?customer_posted=true (2026-10-12: a token-less
      // resend earned "Missing CAPTCHA token", and asking to press Join again looped)
      if (r.url.includes("/challenge")) {
        if (!visibleCheckOk) return done(false);
        try { sessionStorage.setItem("qua-base", base == null ? "" : String(base)); } catch (e) {}
        return location.assign(r.url);
      }
      done(false);
    }).catch(() => done(false));
  }
  const readCount = () => fetch("/?sections=qua-count&t=" + Date.now(), { credentials: "same-origin", cache: "no-store" })
    .then(r => r.json()).then(j => { const m = /data-count="([0-9]+)"/.exec(j["qua-count"] || ""); return m ? +m[1] : null; }).catch(() => null);
  let base = null;
  function joined(n) {
    msg.textContent = ""; form.hidden = true; $("#welcomeBack").hidden = false;
    $("#welcomeBack p").textContent = "You're on the list."; $("#viewBadge").hidden = false; welcome(n);
  }
  function already() {
    msg.textContent = ""; btn.disabled = false; form.hidden = true; $("#welcomeBack").hidden = false;
    $("#welcomeBack p").textContent = "You're already an Early Duck. Your number is in your welcome email.";
    $("#viewBadge").hidden = true; $("#notYou").hidden = false;
  }
  const send = sendInBackground(form, (ok, again) => {
    if (!ok) { msg.textContent = "That didn't go through. Please try again in a moment."; btn.disabled = false; return; }
    settle();
  }, true);
  // a new Early Duck raises the count within seconds (Flow); an existing one leaves it where it was
  function settle() {
    let tries = 0;
    (function poll() {
      readCount().then(c => {
        if (base == null || c == null) return joined(c || undefined);
        if (c > base) return joined(c);
        if (++tries < 12) return setTimeout(poll, 1000);
        already();
      });
    })();
  }
  form.submit = () => readCount().then(c => { base = c; return send(); });
  protect(form);
  form.addEventListener("submit", e => {
    const email = $("#email").value.trim();
    const stop = (text, el) => { e.preventDefault(); e.stopImmediatePropagation(); msg.textContent = text; el.focus(); };
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return stop("Enter a valid email address, like name@example.com.", $("#email"));
    if (!$("#consent").checked) return stop("Tick the box to get our emails.", $("#consent"));
    msg.textContent = "Joining…"; btn.disabled = true; remember(email);
    // no number in the tags: the person's number is set once, by Flow, in the customer field qua.early_duck_number
    // (a repeat sign-up can therefore never add a second number)
    if (!isBound(form)) protect(form); // after a used check, protect the form again
    if (isBound(form)) return; // Shopify's check takes it from here, then calls form.submit()
    e.preventDefault();
    waitForBinding(form).then(b => b ? form.requestSubmit() : form.submit());
  });

  /* The badge name follows through a second, hidden Shopify form, protected the same way */
  const nameForm = Object.assign(document.createElement("form"), { method: "post", action: "/contact#contact_form", hidden: true });
  nameForm.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[email]"><input type="hidden" name="contact[first_name]"><input type="hidden" name="contact[last_name]"><input type="hidden" name="contact[tags]" value="newsletter, waitlist, early-duck, badge-named"><input type="hidden" name="contact[accepts_marketing]" value="true">';
  document.body.appendChild(nameForm);
  nameForm.submit = sendInBackground(nameForm, () => {}, false);
  protect(nameForm);
  function remember(email) { try { sessionStorage.setItem("qua-email", email); } catch (e) {} }
  window.quaSaveName = name => {
    let email = ""; try { email = sessionStorage.getItem("qua-email") || ""; } catch (e) {}
    if (!email) return;
    const [first, ...rest] = name.split(/\s+/);
    nameForm.elements["contact[email]"].value = email; nameForm.elements["contact[first_name]"].value = first; nameForm.elements["contact[last_name]"].value = rest.join(" ");
    // Shopify keeps an existing customer's name fields as they are, so the badge name is saved as a tag too (commas would split it)
    nameForm.elements["contact[tags]"].value = "newsletter, waitlist, early-duck, badge-named, Name: " + name.replace(/,/g, " ").replace(/\s+/g, " ").trim().slice(0, 60);
    if (isBound(nameForm)) nameForm.requestSubmit(); else waitForBinding(nameForm).then(b => b ? nameForm.requestSubmit() : nameForm.submit());
  };
  if (/[?&]customer_posted=true/.test(location.search)) {
    btn.disabled = true;
    history.replaceState(null, "", location.pathname);
    // back from Shopify's check page: the count before they joined was kept, so new and returning are told apart
    let kept = null; try { kept = sessionStorage.getItem("qua-base"); sessionStorage.removeItem("qua-base"); } catch (e) {}
    base = kept ? +kept : null;
    requestAnimationFrame(() => { $("#waitlist").scrollIntoView(); msg.textContent = "Joining…"; settle(); });
  }

  (() => {
    const mine = myDuck(); if (!mine || !mine.n) return;
    form.hidden = true; $("#welcomeBack").hidden = false; $("#notYou").hidden = false;
    $("#welcomeBack p").textContent = "You're already Early Duck No. " + fmt(mine.n) + ".";
  })();
  $("#notYou").addEventListener("click", () => {
    try { localStorage.removeItem("qua-duck"); } catch (e) {}
    $("#welcomeBack").hidden = true; $("#notYou").hidden = true; $("#viewBadge").hidden = false; form.hidden = false; btn.disabled = false; $("#email").focus();
  });

  /* ---------- What Early Ducks get: the tiles take turns while in view; a tap chooses one and stops the turning ---------- */
  (() => {
    const wrap = $("#duckPerks"); if (!wrap) return;
    const tiles = $$("#duckPerks .dp"), text = $("#dpText");
    let cur = 0, timer = null, auto = !reduced, visible = false;
    function pick(i) {
      cur = i;
      tiles.forEach((t, k) => { t.classList.toggle("on", k === i); t.setAttribute("aria-selected", k === i); });
      void wrap.offsetWidth; // restart the drawing on the newly chosen icon
      if (text.textContent === tiles[i].dataset.text) return;
      text.classList.add("swap");
      setTimeout(() => { text.textContent = tiles[i].dataset.text; text.classList.remove("swap"); }, reduced ? 0 : 200);
    }
    const loop = () => { clearTimeout(timer); if (auto && visible) timer = setTimeout(() => { pick((cur + 1) % tiles.length); loop(); }, 2200); }; // quick enough that a visitor sees it move
    tiles.forEach((t, i) => t.addEventListener("click", () => { auto = false; clearTimeout(timer); pick(i); }));
    wrap.addEventListener("mouseenter", () => clearTimeout(timer));
    wrap.addEventListener("mouseleave", () => { if (auto) { pick(cur); loop(); } });
    new IntersectionObserver(es => { visible = es[0].isIntersecting; if (visible) { pick(cur); loop(); } else clearTimeout(timer); }, { threshold: .6 }).observe(wrap);
  })();

  /* ---------- App phones on a phone: a swipeable row with a pager ---------- */
  const phones = $("#phones"), pager = $$("#pager span");
  phones.addEventListener("scroll", () => {
    const items = [...phones.children], mid = phones.scrollLeft + phones.clientWidth / 2;
    let best = 0, dist = Infinity;
    items.forEach((li, i) => { const d = Math.abs(li.offsetLeft + li.offsetWidth / 2 - mid); if (d < dist) { dist = d; best = i; } });
    pager.forEach((p, i) => p.classList.toggle("on", i === best));
  }, { passive: true });
  if (matchMedia("(max-width: 760px)").matches) requestAnimationFrame(() => { const home = phones.children[1]; phones.scrollLeft = home.offsetLeft - (phones.clientWidth - home.offsetWidth) / 2; });

  if (!motion) { $$(".fc").forEach(f => f.style.removeProperty("opacity")); return; }

  // The hero measures the page, so the scenes wait until fonts and images have settled (2.5 s at most)
  const loaded = document.readyState === "complete" ? null : new Promise(r => addEventListener("load", r, { once: true }));
  Promise.race([Promise.all([document.fonts && document.fonts.ready, loaded]), new Promise(r => setTimeout(r, 2500))]).then(scenes);

  function scenes() {
  /* ---------- Scroll scenes ---------- */
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });

  // Hero: the bottle starts small above the headline, grows, turns twice, and the four features come and go
  function heroFit() {
    const H = qb.offsetHeight, hd = $("#headline");
    const top = header.getBoundingClientRect().bottom + 16;
    const bottom = innerHeight - hd.offsetHeight - parseFloat(getComputedStyle(hd).bottom) - 12;
    const r = qb.getBoundingClientRect(), mid = (r.top + r.bottom) / 2 - (gsap.getProperty(qb, "y") || 0);
    const s = Math.max(.3, Math.min(.72, (bottom - top) / H));
    return { s, y: (top + bottom) / 2 - mid };
  }
  const fcs = $$(".fc"), idx = $$(".findex li");
  let cur = -1;
  const setIdx = i => { if (i === cur) return; cur = i; idx.forEach((li, k) => li.classList.toggle("on", k === i)); };
  const turn = { f: 0 };
  const tl = gsap.timeline({ defaults: { ease: "power2.out" }, scrollTrigger: { trigger: ".story", start: "top top", end: "bottom bottom", scrub: phone ? .25 : .6, invalidateOnRefresh: true },
    onUpdate() { const t = this.time(); setIdx(t < 3.1 ? 0 : t < 4.9 ? 1 : t < 6.7 ? 2 : 3); } });
  tl.fromTo(qb, { scale: () => heroFit().s, y: () => heroFit().y }, { scale: 1, y: 0, duration: 1, ease: "power2.inOut" }, .15)
    .to("#headline", { autoAlpha: 0, y: -40, duration: .8 }, .2)
    .to(turn, { f: COUNT * 2 - 1, duration: 8.4, ease: "none", onUpdate: () => draw(Math.round(turn.f) % COUNT) }, 1)
    .to([".findex", ".fbar"], { autoAlpha: 1, duration: .5 }, 1.2)
    .fromTo("#fbar", { scaleX: 0 }, { scaleX: 1, duration: 8, ease: "none" }, 1.4);
  [[1.4, 3], [3.2, 4.8], [5, 6.6], [6.8, null]].forEach(([a, b], i) => {
    tl.fromTo(fcs[i], { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: .6 }, a);
    if (b) tl.to(fcs[i], { autoAlpha: 0, y: -24, duration: .45 }, b - .3); // gone before the next caption arrives
  });
  tl.to({}, { duration: 1 });
  docEl.classList.add("ready");

  // Problem: each line brightens in turn, then the first three settle back and "Not your water." stays lit
  // (on phones the lines are too close together for scrolling to drive them, so they light one by one as they arrive)
  const lines = $$("#lines p");
  const dim = () => eff() === "light" ? .55 : .32; // the settled lines stay readable in light mode too
  // replays each time you scroll down into it; scrolling back up above it resets the lines for next time
  if (phone) gsap.timeline({ scrollTrigger: { trigger: "#lines", start: "top 75%", toggleActions: "restart none none reset" } })
    .to(lines, { opacity: 1, stagger: .35, duration: .6, ease: "power2.out" })
    .to(lines.slice(0, 3), { opacity: dim, duration: .8, ease: "power2.inOut" }, "+=.4");
  else gsap.timeline({ scrollTrigger: { trigger: "#lines", start: "top 78%", end: "bottom 40%", scrub: true } })
    .to(lines, { opacity: 1, stagger: .5, duration: .5, ease: "none" })
    .to(lines.slice(0, 3), { opacity: dim, duration: .6, ease: "none" });

  // App: four phones stacked in the middle fan out as you scroll (wider screens)
  ScrollTrigger.matchMedia({
    "(min-width: 761px)": () => {
      $$("#phones li").forEach((li, i) => gsap.fromTo(li,
        { xPercent: (1.5 - i) * 100, rotation: 0, y: 0, scale: .92 },
        { xPercent: 0, rotation: +li.dataset.r, y: +li.dataset.y, scale: 1, ease: "none",
          scrollTrigger: { trigger: "#phones", start: "top 95%", end: "center 55%", scrub: .6 } }));
    }
  });
  }
})();